import ROUTES, { DOCTOR_ROUTES } from "../routes/patientRoutes/routePaths";

const value = (...values) =>
  values.find((candidate) => candidate !== undefined && candidate !== null && String(candidate).trim()) ??
  null;

export function getNotificationRoute(notification, role = "patient") {
  if (!notification) return null;

  const metadata =
    notification.metadata || notification.data || notification._raw?.metadata || {};
  const type = String(notification.type || "").toUpperCase();
  const event = String(notification.event || "").toLowerCase();
  const targetId = value(
    notification.targetId,
    metadata.targetId,
    metadata.postId,
    metadata.rendezvousId,
    metadata.appointmentId,
    metadata.conversationId,
    metadata.requestId
  );
  const secondaryId = value(
    notification.secondaryId,
    metadata.secondaryId,
    metadata.commentId,
    metadata.messageId
  );

  if (type === "LIKE" || type === "COMMENT" || event.includes("like.created") || event.includes("comment.created")) {
    if (!targetId) return null;
    const query = new URLSearchParams({ postId: String(targetId) });
    if ((type === "COMMENT" || event.includes("comment.created")) && secondaryId) {
      query.set("commentId", String(secondaryId));
    }
    const path = role === "doctor"
      ? DOCTOR_ROUTES.MEDICAL_QUESTIONS
      : "/medical-questionspage";
    return `${path}?${query.toString()}`;
  }

  if (
    type === "NEW_APPOINTMENT" ||
    type === "APPOINTMENT_UPDATE" ||
    type === "APPOINTMENT" ||
    event.includes("rendezvous") ||
    event.includes("appointment")
  ) {
    const query = new URLSearchParams({ tab: "upcoming" });
    if (targetId) query.set("highlight", String(targetId));
    const path = role === "doctor"
      ? DOCTOR_ROUTES.APPOINTMENTS
      : ROUTES.APPOINTMENTS;
    return `${path}?${query.toString()}`;
  }

  if (type === "AUTH_REQUEST" || event.includes("doctor.account.")) {
    if (role === "doctor") return DOCTOR_ROUTES.PROFILE;
    return "/profile/access-requests";
  }

  if (type === "DATA_ACCESS" || event.includes("data_access")) {
    if (role === "doctor") {
      const patientId = value(metadata.patientId, notification.patientId);
      return patientId
        ? `/doctor/patients/${encodeURIComponent(String(patientId))}/DoctorOverviewsPage`
        : null;
    }
    return "/profile/access-requests";
  }

  if (type === "PRESCRIPTION" || event.includes("prescription")) {
    return role === "doctor" ? "/Perscription" : ROUTES.MEDICINES;
  }

  if (type === "RELATIVE" || event.includes("relative")) {
    return "/profile/relatives";
  }

  if (
    type === "MESSAGE" ||
    event.includes("chat.message") ||
    event.includes("message")
  ) {
    const conversationId = value(notification.conversationId, metadata.conversationId);
    const peerId = value(
      metadata.fromUserId,
      notification.fromUserId,
      metadata.senderId
    );
    const path = role === "doctor"
      ? DOCTOR_ROUTES.MESSAGES
      : ROUTES.MESSAGING;
    const query = new URLSearchParams();
    if (conversationId) query.set("conversationId", String(conversationId));
    const isDoctorPeer =
      String(metadata.conversationType || "").toUpperCase() === "DOCTOR_DOCTOR" ||
      String(metadata.fromRole || metadata.senderRole || "").toLowerCase() === "doctor";
    if (peerId) {
      const peerKey =
        role === "doctor" ? (isDoctorPeer ? "doctorId" : "patientId") : "doctorId";
      query.set(peerKey, String(peerId));
    }
    return query.size ? `${path}?${query.toString()}` : path;
  }

  if (notification.link) return String(notification.link);
  return null;
}
